// TODO: migrate from legacy CI tooling: resolve ts-* and/or eslint-* directives below (including inline comments)
/* eslint-disable @typescript-eslint/no-empty-object-type, @typescript-eslint/no-unused-vars, no-empty-pattern */

import React from "react";
import MFAMapWrapper from "./MFAMapWrapper";
import { HeatmapDropdown, MeasureTool, OrthoDropdown } from "./MapControls";

type Props = {};

const MFAMapViewer = ({}: Props) => {
	return (
		<div
			style={{
				width: "100%",
				height: "100%",
				backgroundColor: "#a2a8a4",
				borderRadius: "0 0 8px 8px",
				overflow: "hidden",
				position: "relative",
				display: "flex",
				flexDirection: "column",
			}}
		>
			<MFAMapWrapper />
		</div>
	);
};

export default MFAMapViewer;
